<template>
  <div id="layout">
    <div v-if="loading" class="layout-loading">
      <div class="icon"><a-spin /></div>
    </div>

    <a-layout id="components-layout-custom-trigger">
      <!-- <a-layout-sider v-model="collapsed" :trigger="null" collapsible> -->
        <a-layout-sider v-model="collapsed" id="layout-sider"  collapsible>

        <template v-slot:trigger>
          <div>{{collapsed?"展开":"收起"}}</div>
        </template>

        <a-menu
          v-if="admin"
          theme="dark"
          mode="inline"
          :selected-keys="[currentMenu.menu.id]"
          :open-keys="openKeys"
          @click="clickChange"
          @openChange="onOpenChange"
        >
          <template v-for="menu in admin.menu">
            <a-menu-item v-if="!menu.children || menu.children.length === 0" :key="menu.id" @click="goPage(menu.url)">
              <a-icon :type="menu.icon" />
              <span>{{ menu.name }}</span>
            </a-menu-item>

            <a-sub-menu v-else :key="menu.id">
              <span slot="title">
                <a-icon v-if="menu.icon" :type="menu.icon" /><span>{{ menu.name }}</span>
              </span>
              <template v-for="grandson in menu.children">
                <a-menu-item v-if="!grandson.children || grandson.children.length === 0" :key="grandson.id" @click="goPage(grandson.url)">
                  <a-icon v-if="grandson.icon" :type="grandson.icon" />
                  <span>{{ grandson.name }}</span>
                </a-menu-item>
                <a-sub-menu v-else :key="grandson.id" :title="grandson.name">
                  <a-menu-item v-for="finalson in grandson.children" :key="finalson.id" @click="goPage(finalson.url)">
                    <a-icon v-if="finalson.icon" :type="finalson.icon" />
                    <span>{{ finalson.name }}</span>
                  </a-menu-item>
                </a-sub-menu>
              </template>
            </a-sub-menu>
          </template>
        </a-menu>
      </a-layout-sider>
      
      <a-layout>
        <a-layout-header id="layout-header" style="height:1px">
          <a-row type="flex">
            <a-col flex="1" style="margin-top:-10px;margin-left:-8px">
              <!-- <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="() => (collapsed = !collapsed)"
              /> -->
            </a-col>

            <a-col class="right-side" >
              <!-- <a-dropdown placement="bottomRight" style="width:150px">
              <span class="avatar">
                <a-avatar size="small" icon="user" />
                <template v-if="admin">{{ admin.name }}</template>
              </span>
              <template v-slot:overlay>
                <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
                  <a-menu-item key="password" @click="updatePassword">
                    <a-icon type="lock" />修改密码
                  </a-menu-item>
                  <a-menu-item key="sync" @click="build" v-if="admin && $helper.accessTo('SystemController', 'build')">
                    <a-icon type="sync" />更新系统
                  </a-menu-item>
                  <a-menu-item key="logout" @click="logout">
                    <a-icon type="logout" />退出登录
                  </a-menu-item>
                </a-menu>
              </template>
              </a-dropdown> -->
            </a-col>
          </a-row>
        </a-layout-header>

        <Tab style="margin-top:6px;"></Tab>


        <a-row type="flex" id="bread" style="background:white;margin-bottom:6px">
          <a-col flex="1" >
            <a-breadcrumb >
              <a-breadcrumb-item>
                <a-icon v-if="currentMenu.parent.icon" :type="currentMenu.parent.icon" />
                <span>{{ currentMenu.parent.name }}</span>
              </a-breadcrumb-item>
              <a-breadcrumb-item>
                {{ currentMenu.menu.name }}
              </a-breadcrumb-item>
            </a-breadcrumb>
          </a-col>

          <a-col class="right-side" style="margin-top:-1px">

            <!-- 切换账号 -->
            <a-dropdown
              v-if="admin && admin.accounts && admin.accounts.length > 1"
              placement="bottomLeft"
            >
              <span class="switch-account">
                <a-icon type="swap" />
                <span class="switch-text">切换账号</span>
              </span>

              <template v-slot:overlay>
                <a-menu>
                  <a-menu-item
                    v-for="item in admin.accounts"
                    :key="item.id"
                    @click="switchAccount(item)"
                  >
                    <a-icon
                      type="check"
                      v-if="admin && item.id === admin.id"
                      style="color:#52c41a"
                    />
                    <!-- {{ item.name }}（{{ item.username }}） -->
                    {{ item.name }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>

            <!-- 当前账号 -->
            <a-dropdown placement="bottomRight" style="margin-right:10px">
            <span class="avatar">
              <a-avatar size="small" icon="user" />
              <template v-if="admin">{{ admin.name }}</template>
            </span>
            <template v-slot:overlay>
              <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
                <a-menu-item key="password" @click="updatePassword">
                  <a-icon type="lock" />修改密码
                </a-menu-item>
                <a-menu-item key="sync" @click="build" v-if="admin && $helper.accessTo('SystemController', 'build')">
                  <a-icon type="sync" />更新系统
                </a-menu-item>
                <a-menu-item key="logout" @click="logout">
                  <a-icon type="logout" />退出登录
                </a-menu-item>
              </a-menu>
            </template>
            </a-dropdown>
          </a-col>
        </a-row>
        

        

        <slot name="search" ></slot>

        <a-layout-content id="layout-content" style="margin-top:-2px">
          <slot name="content"></slot>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <password-form
      v-if="showPasswordForm"
      :showPasswordForm.sync="showPasswordForm"
      :model="passwordModel"
      @success="refresh"
    />

    <build-form
        v-if="showBuildForm"
        :showBuildForm.sync="showBuildForm"
        @success="refresh"
    />
  </div>
</template>

<style lang="less">
@import 'Layout';
</style>

<script>
import Layout from './Layout'
export default Layout
</script>

